/* Parallel detail API requests during shapefile attribute enrichment. */
export const EXPORT_DETAIL_FETCH_CONCURRENCY = 100;
